export default {
  // 欢迎信息
  welcome: {
    title: '欢迎回来！',
    greeting: '👋',
  },
  
  // 按钮
  buttons: {
    createCampaign: '新建营销计划',
  },
  
  // 页面标题
  titles: {
    yourCampaign: '您的计划',
    campaignActions: '活动操作',
    campaignName: '活动名称',
  },
  
  // 你的活动标签页
  yourCampaignTabs: {
    reviewQuotedInfluencers: '审核新合作',
    shipProduct: '寄送样品',
    approveDelivery: '确认交付',
    completeCollaboration: '完成合作',
    renewCampaign: '增加预算',
    reviewTimelineExtension: '审核延期申请',
    confirmInviteList: '确认邀请列表',
    influencerAccessSetup: '开通达人权限',
    counterOfferUnderAdvertiserReview: '审核报价',
    selectFromAhaPicks: '从 Aha Picks 中选择',
    selectFromAhaPicksTooltip: '从 AhaCreator 注册达人池中为您挑选最佳匹配，帮助您更快匹配达人。',
  },

  // 文案
  messages: {
    confirmCollaborationTip:
      '尽快审核申请有助于锁定达人档期并提升合作成功率；反馈拖延会增加达人失联的风险。',
    noPendingActions: '太棒了！当前暂无待办事项～',
    noMatchingActions: '暂无符合筛选条件的待办事项。',
    selectCampaignName: '请选择活动名称',
    searchInfluencer: '按达人名称或账号搜索',
    selectFromAhaPickTip: '您审核得越快，我们就能越快发送下一批。',
    confirmCollaborationAlertTip: '及时回复有助于锁定达人档期并减少流失。',
    approveExtensionRequestPrompt: '通过这条延期申请？',
    approveAllExtensionRequestsPrompt: '通过全部 {count} 条延期申请？',
    approveExtensionRequestsImmediateEffect: '此操作将立即生效。',
    approveAllExtensionRequestsAction: '全部通过（{count}）',
    approveExtensionRequestsSuccess: '延期申请已通过。',
    approveExtensionRequestsFailed: '延期申请通过失败。',
  },

  filters: {
    language: '语言',
    platform: '平台',
    allLanguages: '全部语言',
    allPlatforms: '全部平台',
    unknownLanguage: '未知语言',
  },

  // 充值横幅
  rechargeBanner: {
    depositNow: '立即充值，领取额外广告额度',
    depositWithAmounts: '现在充值 {amount}，可获 {credits} 广告额度',
    depositButton: '立即充值',
  },

  // 平台费优惠横幅
  lowerFreeBanner: {
    badge: '限时优惠 · 平台服务费 5 折',
    descriptionBefore: '平台服务费已从 ',
    oldRate: '10%',
    descriptionMiddle: ' 降至 ',
    newRate: '5%',
    descriptionAfter: '，每笔订单更划算。',
  },

  // 帮助区块
  help: {
    title: '我们随时为您提供帮助',
    contact: '联系您的 AhaCreator 支持团队',
    desc: '您可享受我们的专业支持服务。',
  },

  // 资源卡片
  resources: {
    title: '资源',
    cardTitle: 'AhaCreator 创意最佳实践',
    cardDesc:
      '了解在 AhaCreator 上打造更吸引、更有影响力的广告创意的最佳做法。',
  },

  // 报告区块
  report: {
    selectCampaign: '选择营销计划',
  },
  
  // 状态和消息
  status: {
    creating: '创建中…',
  },
  
  // 错误消息
  errors: {
    createCampaignFailed: '创建计划失败，请稍后重试或联系我们',
  },

  // home 通知条
  notification: {
    DMtitle: '消息功能更新',
    DMcontent: '我们收到了您的反馈，并正在升级消息功能，以增强您的沟通体验。消息功能将于10月17日起暂时不可用。一旦达人申请获得批准，您仍然可以通过查看合作详情页面上的邮箱地址与达人联系。我们将尽快通知您，以便您可以使用改进后的版本。感谢您的理解和支持！',
  },
};
